import axios from "axios";

// const base_url = "http://gameapi.theinnercitymission.net";
const base_url = "https://sweetplateapi.sweetplate.org/api";
// const base_url = "http://localhost:32211/api";

export const apiClient = axios.create({
  baseURL: base_url,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token to every request if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("sp_admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Register Admin
export const loginAdmin = async (email, password) => {
  try {
    const payload = { email, password };
    const response = await apiClient.post("/splate/auth/login", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

export const getUserCount = async () => {
  const res = await apiClient.get("/splate/users");
  return res.data; // { count: 0 }
};

// Get total users
export const getAllUsers = async ({page = 1, limit = 20, role}) => {
  try {
     const res = await apiClient.get("/splate/users", {params: {page, limit, role}});
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

// Get total users
export const getAdminProfile = async () => {
  try {
     const res = await apiClient.get("/splate/auth/me");
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

// export const deleteUser = async (userId) => {
//   try {
//     const res = await apiClient.delete(`/splate/users/${userId}`);
//     return res.data;
//   } catch (error) {
//     console.log(
//       "Failed to delete user:",
//       error.response?.data || error.message
//     );
//     throw error;
//   }
// };


export const getAllOrders = async () => {
  try {
     const res = await apiClient.get("/splate/orders/all-orders");
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const getLocations = async () => {
   try {
     const res = await apiClient.get("/splate/allowed-cities");
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllProducts = async () => {
   try {
     const res = await apiClient.get("/splate/products");
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const getCategories = async () => {
   try {
     const res = await apiClient.get("/splate/categories");
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const createCategory = async (payload) => {
  try {
  const res = await apiClient.post("/splate/categories", payload);
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const createLocation = async (payload) => {
  try {
  const res = await apiClient.post("/splate/allowed-cities", payload);
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const updateCategory = async (id, payload) => {
  try {
  const res = await apiClient.put(`/splate/categories/${id}`, payload);
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const updateLocation = async (cityId, payload) => {
  try {
  const res = await apiClient.put(`/splate/allowed-cities/${cityId}`, payload);
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteLocation = async (cityId) => {
  try {
  const res = await apiClient.delete(`/splate/allowed-cities/${cityId}`);
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteProduct = async (productId) => {
  try {
  const res = await apiClient.delete(`/splate/products/${productId}`);
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteOrder = async (orderId) => {
  try {
  const res = await apiClient.delete(`/splate/orders/${orderId}`);
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};


export const getApprovedCampaigns = async () => {
  const res = await apiClient.get("/admin/campaign/approved");
  return res.data; // array
};

export const getAllCampaigns = async () => {
  const res = await apiClient.get("/admin/campaign/all");
  return res.data; // array
};

// Create campaign - file upload
export const createCampaign = async ({ title, description, goalAmount, imageFile }) => {
  const form = new FormData();
  form.append("title", title);
  form.append("description", description);
  form.append("goalAmount", goalAmount);
  if (imageFile) form.append("image", imageFile); // backend expects 'image' file

  const res = await apiClient.post("/admin/campaign", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// Approve campaign
export const approveCampaign = async (id) => {
  const res = await apiClient.patch(`/admin/campaign/${id}/approved`);
  return res.data;
};

// Create blog
export const createBlog = async ({ title, content, image }) => {
  const res = await apiClient.post("/admin/blogs", { title, content, image });
  return res.data;
};

// total donation (may accept query param e.g. ?from=...&to=... - adapt as needed)
export const getTotalDonation = async (params = {}) => {
  const res = await apiClient.get("/admin/total-donation", { params });
  return res.data;
};

// analytics
export const getAnalytics = async () => {
  const res = await apiClient.get("/admin/analytics");
  return res.data; // should contain user, donation, campaigns stats
};


// 🔹 Login Admin
//  export const loginAdmin = async ({ email, password }) => {
//    try {
//      const payload = { email, password };
//      const response = await apiClient.post("/login", payload);
//      return response.data;
//   } catch (error) 
//   {     console.error("Login failed:", error.response?.data || error.message);
//     throw error;
//   }
// };


export const confirmPaymentApi = async (id) => {
  try {
  const res = await apiClient.post(`/splate/orders/${id}/confirm-payment`);
  return res.data;
  } catch (error) {
    console.log("Failed to confirm payment:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllRiders = async (id) => {
  try {
  const res = await apiClient.get("/splate/riders");
  return res.data;
  } catch (error) {
    console.log("Failed to get riders:", error.response?.data || error.message);
    throw error;
  }
};

export const adminUpdateOrder = async (orderId, data) => {
  try {
  // data contains { to: "status", newRiderId: "id" }
  const response = await apiClient.patch(`/splate/admin/orders/${orderId}`, data);
  return response.data;
  } catch (error) {
    console.log("Failed to update order:", error.response?.data || error.message);
    throw error;
  }
};

// Fetch the current settings
export const getSystemSettings = async () => {
  try {
  const response = await apiClient.get('/splate/admin/settings');
  return response.data;
 } catch (error) {
    console.log("Failed to get system settings:", error.response?.data || error.message);
    throw error;
  }
};

// Update the settings
export const updateSystemSettings = async (settingsData) => {
  try{
  const response = await apiClient.patch('/splate/admin/settings', settingsData);
  return response.data;
 } catch (error) {
    console.log("Failed to update system settings:", error.response?.data || error.message);
    throw error;
  }
};

export const notificationSender = async (payload) => {
  try{
  const response = await apiClient.post('/splate/notifications/send-broadcast', payload);
  return response.data;
 } catch (error) {
    console.log("Failed to send notification:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchAllUsers = async (params = {}) => {
  try{
  const response = await apiClient.get("/splate/admin/users", { params });
  return response.data;
 } catch (error) {
    console.log("Error:", error.response?.data || error.message);
    throw error;
  }
};

export const getUserById = async(userId) => {
  try{
  const response = await apiClient.get(`/splate/admin/users/${userId}`);
  return response.data;
 } catch (error) {
    console.log("Error:", error.response?.data || error.message);
    throw error;
  }
};

export const updateUser = async(userId, data) => {
  try{
  const response = await apiClient.patch(`/splate/admin/users/${userId}`, data);
  return response.data;
 } catch (error) {
    console.log("Error:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteUser = async(userId) => {
  try{
  const response = await apiClient.delete(`/splate/admin/users/${userId}`);
  return response.data;
 } catch (error) {
    console.log("Error:", error.response?.data || error.message);
    throw error;
  }
};

export const banUser = async(userId, reason) => {
  try{
  const response = await apiClient.patch(`/splate/admin/users/${userId}/ban`, { reason });
  return response.data;
 } catch (error) {
    console.log("Error:", error.response?.data || error.message);
    throw error;
  }
};

export const unbanUser = async(userId) => {
  try{
  const response = await apiClient.patch(`/splate/admin/users/${userId}/unban`);
  return response.data;
 } catch (error) {
    console.log("Error:", error.response?.data || error.message);
    throw error;
  }
};
